import {
	// 获得交易订单分页
	orderPageApi,
	// 获取交易订单发票
	getOrderInvoiceApi
} from '@/apis/ins.js'
export default {
	async orderPage(context, params) {
		return orderPageApi(params)
	},
	async getOrderInvoice(context, payload) {
		return getOrderInvoiceApi(payload)
	}
}